import { render, staticRenderFns } from "./WidgetAddItem.vue?vue&type=template&id=4fd981a4&scoped=true&"
import script from "./WidgetAddItem.vue?vue&type=script&lang=js&"
export * from "./WidgetAddItem.vue?vue&type=script&lang=js&"
import style0 from "./WidgetAddItem.vue?vue&type=style&index=0&id=4fd981a4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd981a4",
  null
  
)

export default component.exports